(function () {
  "use strict";
  if (window.SAEQuickAdd) { window.SAEQuickAdd.initialize(); return; }
  var bindings = new WeakMap();
  var states = new Set();
  var pending = new Set();
  var queue = Promise.resolve();
  var bridgeAPI = null;
  var cartWaiter = null;

  function refreshCart() {
    var api = window.Udesly;
    if (!api || typeof api.on !== "function" || typeof api.dispatch !== "function" || !document.querySelector('[data-node-type="commerce-cart-wrapper"]')) return Promise.resolve(false);
    if (bridgeAPI !== api) {
      bridgeAPI = api;
      api.on("cart-updated", function () { if (cartWaiter) cartWaiter(true); });
    }
    return new Promise(function (resolve) {
      var timer;
      cartWaiter = function (refreshed) {
        clearTimeout(timer);
        cartWaiter = null;
        resolve(refreshed);
      };
      timer = setTimeout(function () { if (cartWaiter) cartWaiter(false); }, 6000);
      // Use the existing adapter's refresh path, which formats prices and redraws the drawer.
      // Its product-added event has a legacy duplicate-event guard; quick-add does not use it.
      try { api.dispatch("cart-should-be-updated"); } catch (_) { if (cartWaiter) cartWaiter(false); }
    });
  }

  function message(state, text, showCart) {
    state.status.textContent = text;
    state.cart.hidden = !showCart;
  }
  function matching(state, selections, availableOnly) {
    return state.data.variants.filter(function (variant) {
      return (!availableOnly || variant.available) && selections.every(function (value, index) {
        return value === null || variant.options[index] === value;
      });
    });
  }
  function exactVariant(state) {
    if (state.data.defaultOnly) return state.data.variants.find(function (variant) { return variant.available; });
    if (state.selected.some(function (value) { return value === null; })) return null;
    return matching(state, state.selected, true)[0] || null;
  }

  function update(state) {
    var busy = pending.has(state.key);
    state.root.setAttribute("aria-busy", String(busy));
    state.groups.forEach(function (group, position) {
      var earlier = state.order.slice(0, position);
      var isAction = group.index === state.actionIndex;
      var complete = earlier.every(function (index) { return state.selected[index] !== null; });
      group.buttons.forEach(function (button) {
        var choices = state.selected.map(function (value, index) { return earlier.indexOf(index) === -1 ? null : value; });
        choices[group.index] = button.dataset.value;
        var variants = matching(state, choices, true);
        var available = variants.length > 0;
        button.disabled = busy || !available || (isAction && !complete);
        button.setAttribute("aria-pressed", String(state.selected[group.index] === button.dataset.value));
        button.setAttribute("aria-label", (isAction ? "Add " : "Choose ") + group.label + ": " + button.dataset.value + (isAction && variants[0] ? " — " + variants[0].price : "") + (!available ? " — unavailable" : ""));
      });
      var value = state.selected[group.index];
      group.legend.textContent = group.label + (value !== null ? ": " + value : "");
    });
    if (state.direct) state.direct.disabled = busy || !state.data.variants.some(function (variant) { return variant.available; });
    var priceMatches = matching(state, state.selected, true);
    var prices = new Set(priceMatches.map(function (variant) { return variant.price; }));
    if (state.price) state.price.textContent = prices.size === 1 ? priceMatches[0].price : state.initialPrice;
  }

  function productStates(key) {
    return Array.from(states).filter(function (state) { return state.key === key && state.root.isConnected; });
  }

  function add(state, variant, button) {
    if (!variant || !variant.available || pending.has(state.key)) return;
    pending.add(state.key);
    var peers = productStates(state.key);
    peers.forEach(function (peer) { message(peer, "Adding…", false); update(peer); });
    var buttonText = button && button.textContent;
    if (button) button.textContent = "Adding…";
    var task = queue.then(async function () {
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/";
      var response, body;
      try {
        response = await fetch(root + "cart/add.js", {
          method: "POST", credentials: "same-origin",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
        });
      } catch (_) {
        peers.forEach(function (peer) { message(peer, "Couldn’t confirm the addition. Check your cart before trying again.", true); });
        return;
      }
      try { body = await response.json(); } catch (_) {}
      if (!response.ok) {
        var error = body && typeof body.description === "string" ? body.description : "Couldn’t add this option. Please try another size or open the product page.";
        peers.forEach(function (peer) { message(peer, error, true); });
        return;
      }
      var label = state.data.defaultOnly ? state.root.dataset.productTitle : variant.options.join(" / ");
      peers.forEach(function (peer) { message(peer, "Added " + label + ".", true); });
      var refreshed = await refreshCart();
      if (refreshed && state.root.dataset.openCart !== "false" && state.root.isConnected) {
        var wrappers = Array.from(document.querySelectorAll('[data-node-type="commerce-cart-wrapper"]'));
        var wrapper = wrappers.find(function (node) { return node.getClientRects().length > 0; }) || wrappers[0];
        if (wrapper) wrapper.dispatchEvent(new CustomEvent("wf-change-cart-state", { bubbles: true, detail: { open: true } }));
      }
      document.dispatchEvent(new CustomEvent("sae:cart-added", { detail: { productId: state.key, variantId: variant.id, quantity: 1, drawerRefreshed: refreshed } }));
    });
    // Serialize our mutations and native cart refreshes, including different products.
    queue = task.catch(function () {
      peers.forEach(function (peer) { message(peer, "Check your cart to confirm this addition.", true); });
    }).then(function () {
      pending.delete(state.key);
      if (button) button.textContent = buttonText;
      productStates(state.key).forEach(update);
    });
  }

  function initialize() {
    states.forEach(function (state) { if (!state.root.isConnected) states.delete(state); });
    document.querySelectorAll("[data-sae-quick-add]").forEach(function (root) {
      if (bindings.has(root)) return;
      var form = root.querySelector("[data-sae-quick-add-form]");
      var source = root.querySelector("[data-sae-quick-data]");
      var host = root.querySelector("[data-sae-quick-options]");
      var native = root.querySelector("[data-sae-quick-native]");
      var status = root.querySelector("[data-sae-quick-status]");
      var cart = root.querySelector("[data-sae-quick-cart]");
      var data;
      try { data = JSON.parse(source.textContent); } catch (_) { return; }
      if (!form || !host || !native || !status || !cart || !Array.isArray(data.options) || !Array.isArray(data.variants) || !data.variants.length) return;
      if (data.variants.some(function (variant) { return !variant.id || !Array.isArray(variant.options) || variant.options.length !== data.options.length; })) return;
      var order = data.options.map(function (_, index) { return index; });
      var sizeIndex = data.options.findIndex(function (label) { return /(^|\s)size(\s|$)/i.test(label); });
      // Color/style choices come first. Tapping the final size performs the add.
      if (sizeIndex !== -1) order = order.filter(function (index) { return index !== sizeIndex; }).concat(sizeIndex);
      var state = { root: root, form: form, data: data, host: host, status: status, cart: cart, key: root.dataset.productId, selected: data.options.map(function () { return null; }), order: order, actionIndex: order[order.length - 1], groups: [], price: root.querySelector("[data-sae-quick-price]") };
      state.initialPrice = state.price ? state.price.textContent : "";
      bindings.set(root, state);
      states.add(state);
      var instruction = document.createElement("p");
      instruction.className = "sae-quick-instruction";
      instruction.textContent = data.defaultOnly ? "" : order.length === 1 ? "Tap an option to add it." : "Choose " + order.slice(0, -1).map(function (index) { return data.options[index]; }).join(" / ") + ", then tap " + data.options[state.actionIndex] + " to add.";
      if (instruction.textContent) host.appendChild(instruction);
      if (data.defaultOnly) {
        var direct = document.createElement("button");
        direct.type = "button";
        direct.className = "sae-purchase-button";
        direct.textContent = root.dataset.quickLabel || "Quick add";
        direct.addEventListener("click", function () { add(state, exactVariant(state), direct); });
        host.appendChild(direct);
        state.direct = direct;
      } else {
        state.groups = order.map(function (index) {
          var group = document.createElement("fieldset"), legend = document.createElement("legend"), choices = document.createElement("div");
          var label = data.options[index];
          choices.className = "sae-option-buttons";
          group.appendChild(legend); group.appendChild(choices); host.appendChild(group);
          var values = Array.from(new Set(data.variants.map(function (variant) { return variant.options[index]; })));
          var buttons = values.map(function (value) {
            var button = document.createElement("button");
            button.type = "button"; button.className = "sae-purchase-button"; button.textContent = value; button.dataset.value = value;
            button.addEventListener("click", function () {
              if (button.disabled || pending.has(state.key)) return;
              state.selected[index] = value;
              if (index !== state.actionIndex) {
                // A new earlier choice requires an explicit final-size tap again.
                var position = order.indexOf(index);
                order.slice(position + 1).forEach(function (later) { state.selected[later] = null; });
                message(state, "", false);
                update(state);
              } else {
                update(state);
                var variant = exactVariant(state);
                if (variant) add(state, variant, button);
                else message(state, "Choose an available option in each group.", false);
              }
            });
            choices.appendChild(button);
            return button;
          });
          return { index: index, label: label, legend: legend, buttons: buttons };
        });
      }
      form.addEventListener("submit", function (event) {
        event.preventDefault();
        var variant = exactVariant(state);
        if (variant) add(state, variant, state.direct);
        else message(state, "Choose an available option in each group.", false);
      });
      native.querySelectorAll("select, input, button").forEach(function (control) { control.disabled = true; });
      native.hidden = true; host.hidden = false; root.dataset.saeQuickReady = "true";
      update(state);
    });
  }
  window.SAEQuickAdd = { initialize: initialize };
  initialize();
  document.addEventListener("DOMContentLoaded", initialize, { once: true });
  document.addEventListener("shopify:section:load", initialize);
})();
